import { useMobileFiltersContext, ON_BOARDING_STATES } from './OnboardingContext'
import { FieldCheckBox } from './FieldCheckBox'
import Icon from '@/components/snippets/icon/icon'
import { FormOnBoardingButtons } from './OnboardingButtons'
import { useMemo, useState } from 'preact/hooks'

const NEXT_STEP = ON_BOARDING_STATES.CONFIRMATION
const BRANDS = GM_STATE.metaobjects.omneo_brands ?? [
  { icon: 'bag', label: 'shopping', value: 'shopping' },
  { icon: 'cart', label: 'cart', value: 'cart' },
  { icon: 'file', label: 'file', value: 'file' },
  { icon: 'fire', label: 'fire', value: 'fire' }
]

export function OnBoardingBrands() {
  const [showMore, setShowMore] = useState(false)

  const context = useMobileFiltersContext()
  const section = context.getCurrentChild()?.steps[context.config.currentState - 1]
  const selectedBrands = section.brands.reduce((acc, brand) => ({ ...acc, [brand.value]: brand.id }), {})

  const brands = useMemo(() => {
    if (showMore) return BRANDS
    return BRANDS.slice(0, 12)
  }, [showMore])

  const handleNextStep = () => {
    context.handleNextStep(NEXT_STEP)
  }

  return (
    <form
      className={'flex flex-col gap-4'}
      onSubmit={(e) => {
        e.preventDefault()
        const formData = new FormData(e.currentTarget)
        const input = []
        /** Have the fetch here to  */
        formData.forEach((v, k) => {
          input.push({ value: v, id: k })
        })
        /** Have the fetch here to  */
        context.handleUpdateConfig({ brands: input })
        handleNextStep()
      }}
    >
      <div className={'grid h-[calc(4*(62px+8px))] grid-cols-2 gap-2 overflow-y-auto md:grid-cols-3'}>
        {brands.map((brand) => {
          return (
            <FieldCheckBox
              {...{
                name: brand.label,
                value: brand.value,
                required: false,
                checked: selectedBrands[brand.value]
              }}
            >
              <div className={'flex h-full w-full items-center justify-center px-4'}>
                <img src={brand.icon} className={'h-full object-fit'} />
              </div>
            </FieldCheckBox>
          )
        })}
      </div>

      <div className={'flex w-full items-center justify-center'}>
        <button
          type="button"
          className={`btn btn-md btn-text-black flex items-center gap-2 ${showMore ? 'hidden' : ''}`}
          onClick={() => setShowMore(true)}
        >
          <Icon id="plus" />
          <span className={''}>Load more</span>
        </button>
      </div>

      <FormOnBoardingButtons handleSkip={handleNextStep} />
    </form>
  )
}
